/**
 * Les montants, tels qu'ils s'écrivent en français.
 *
 * Deux formats, parce que deux origines : le serveur rend tantôt des euros
 * entiers — une cotisation, un tarif de place — tantôt des centimes, quand
 * la somme vient d'un encaissement Stripe et doit tomber juste au centime.
 *
 * Les confondre coûte cher dans les deux sens : afficher des centimes comme
 * des euros multiplie la somme par cent, et l'inverse la divise. D'où deux
 * noms qui disent lequel on tient.
 */

/** Des euros entiers : « 1 250 € ». L'association ne facture pas au centime. */
export { euros } from './format';

/** Des centimes, rendus au centime près : « 12,50 € ». */
export function eurosDepuisCentimes(centimes: number): string {
  return `${(centimes / 100).toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} €`;
}
